import {
  BUILDER_WIDGET_ROUTES,
  SUBSCRIPTION_NAMES,
  TEXT_CASE,
  TEXT_SIZE_DROPDOWN,
  TEXT_THICKNESS,
} from 'src/constants/builderConstants';
import { COLLECTION_HEADING_TYPES, COLLECTIONS_ROUTE_STYLING } from './CollectionsConfig';
import {
  COLOR_SELECTION_LAYOUTS,
  FILTER_DESIGN_LAYOUTS_DESKTOP,
  FILTER_DESIGN_LAYOUTS_MOBILE,
  PAGINATION_APPEARANCE_LAYOUTS,
  SIZE_SELECTION_LAYOUTS,
} from './layoutSelectibles';
import cloneDeep from 'lodash/cloneDeep';

const DIMENSIONS_DATA = [
  { text: 'Original', value: 'original' },
  { text: 'Small (200 px)', value: '200px' },
  { text: 'Regular (360 px)', value: '360px' },
  { text: 'Medium (600 px)', value: '600px' },
  { text: 'Large (720 px)', value: '720px' },
  { text: 'Custom', value: 'custom' },
  // { text: 'Full Height', value: '100vh' },
];

const TEXT_SIZE_FOR_CAT_COL = [
  ...TEXT_SIZE_DROPDOWN,
  {
    text: 'Display regular (28px)',
    value: 'displayRegular',
    itemLevelClass: { fontSize: '28px !important' },
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.PRO,
      SUBSCRIPTION_NAMES.ELITE,
    ],
  },
  {
    text: 'Display medium (36px)',
    value: 'displayMedium',
    itemLevelClass: { fontSize: '36px !important' },
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.PRO,
      SUBSCRIPTION_NAMES.ELITE,
    ],
  },
  {
    text: 'Display large (48px)',
    value: 'displayLarge',
    itemLevelClass: { fontSize: '36px !important' },
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.PRO,
      SUBSCRIPTION_NAMES.ELITE,
    ],
  },
];

const HEADING_ALIGNMENT = [
  {
    text: 'Left',
    value: 'left',
    iconBaseClass: 'wb-sprite ic-align-left faded',
    iconActiveClass: 'wb-sprite ic-align-left',
  },
  {
    text: 'Centre',
    value: 'center',
    iconBaseClass: 'wb-sprite ic-align-center faded',
    iconActiveClass: 'wb-sprite ic-align-center',
  },
];

// const TEXT_PLACEMENT = [
//   {
//     text: 'Below image',
//     value: 'below-image',
//     subscription: [
//       SUBSCRIPTION_NAMES.ESSENTIAL,
//       SUBSCRIPTION_NAMES.PRO,
//       SUBSCRIPTION_NAMES.ELITE,
//     ],
//   },
//   {
//     text: 'On image',
//     value: 'on-image',
//     subscription: [SUBSCRIPTION_NAMES.PRO, SUBSCRIPTION_NAMES.ELITE],
//   },
// ];

const PAGINATION_STYLE = [
  {
    text: 'Add pagination',
    value: 'add-pagination',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.PRO,
      SUBSCRIPTION_NAMES.ELITE,
    ],
  },
  {
    text: 'Infinite scroll',
    value: 'infinite-scroll',
    subscription: [
      SUBSCRIPTION_NAMES.ESSENTIAL,
      SUBSCRIPTION_NAMES.PRO,
      SUBSCRIPTION_NAMES.ELITE,
    ],
  },
];

export const WIDGET_BY_ROUTE_DEFAULT_STYLES = {
  [BUILDER_WIDGET_ROUTES.COLLECTION]: COLLECTIONS_ROUTE_STYLING,
};

export const WIDGET_BY_ROUTE_STYLE_OUTLINE = {
  [BUILDER_WIDGET_ROUTES.COLLECTION]: [
    // This is treated as one section
    {
      // title: 'Breadcrumbs',
      // isMainSection: true,
      isVisibleForEssential: true,
      subSections: [
        {
          title: 'Page settings',
          isVisibleForEssential: true,
          isParent: true,
          style: { borderBottom: '1px solid #EBEBEB', paddingBottom: '8px' },
          subSections: [
            {
              isVisibleForEssential: false,
              title: 'Page layout and design',
              action: {
                type: 'open_builder_config',
                builderEditKey: 'sortAndFilter',
              },
            },
            {
              isVisibleForEssential: true,
              title: 'Product grid and pagination',
              action: {
                type: 'open_builder_config',
                builderEditKey: 'gridAndPagination',
              },
            },
          ],
        },
        {
          title: 'Page heading',
          isVisibleForEssential: true,
          style: { paddingTop: '8px' },
          isParent: true,
          subSections: [
            {
              title: 'Collection heading',
              action: {
                type: 'open_builder_config',
                builderEditKey: 'caligraphyCollection',
              },
              isVisibleForEssential: false,
            },
            {
              title: 'Category heading',
              action: {
                type: 'open_builder_config',
                builderEditKey: 'caligraphyCategory',
              },
              essentialStyle: {
                paddingBottom: '8px'
              },
              isVisibleForEssential: true
            },
          ],
        },
      ],
    },
  ],
};

export const WIDGET_BY_ROUTE_STYLE_BUILDER_CONFIG = {
  [BUILDER_WIDGET_ROUTES.COLLECTION]: {
    caligraphyCollection: {
      headingType: {
        sectionHeading: 'Collection heading type',
        sectionSubHeading: 'Any heading type chosen will be applied to all collections.',
        tooltipContent: '',
        builder: [
          {
            forType: '',
            element: 'radioButton',
            componentLabel: '',
            handleUpdateConfig: (activeWidgetProps, onChange) => {
              const updatedConfig = cloneDeep(activeWidgetProps);
              const { caligraphyCollection } = updatedConfig;
              if (caligraphyCollection?.isBannerFullWidth) {
                caligraphyCollection.text_size_desktop = 'displayLarge';
                caligraphyCollection.text_size_mobile = 'displayRegular';
                caligraphyCollection.text_thickness = 'regular';
                caligraphyCollection.text_alignment = 'center'
                onChange(updatedConfig)
              }
            },
            accessKey: ['caligraphyCollection', 'heading_type'],
            componentData: [
              {
                label: 'Text (Collection name)',
                id: COLLECTION_HEADING_TYPES.TEXT,
                value: COLLECTION_HEADING_TYPES.TEXT,
              },
              {
                label: 'Image (Collection image)',
                id: COLLECTION_HEADING_TYPES.IMAGE,
                value: COLLECTION_HEADING_TYPES.IMAGE,
              },
              // {
              //   label: 'Custom image/banner',
              //   id: COLLECTION_HEADING_TYPES.CUSTOM_IMG_OR_BANNER,
              //   value: COLLECTION_HEADING_TYPES.CUSTOM_IMG_OR_BANNER,
              // },
            ],
          },
        ],
      },
      imageSection: {
        sectionHeading: 'Image',
        description: '',
        tooltipContent: '',
        isVisible(config) {
          return (config?.caligraphyCollection?.heading_type === COLLECTION_HEADING_TYPES.IMAGE);
        },
        builder: [
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Image height',
            accessKey: ['caligraphyCollection', 'height'],
            dropdownData: DIMENSIONS_DATA,
            customChildRender: false,
            placeholder: '',
            customInputLabel: 'Custom height',
            customInputSuffix: 'px',
            dropdownInfo: 'Mobile image height is best optimised as per mobile phones.'
          },
          {
            forType: '',
            componentLabel: 'Improve text readability',
            componentSubLabel: 'Image overlay',
            element: 'slider',
            accessKey: ['caligraphyCollection', 'overlay'],
            min: 1,
            max: 100,
            suffix: '%',
            step: 1,
          },
          {
            forType: '',
            element: 'checkbox',
            componentLabel: 'Make image full width',
            accessKey: ['caligraphyCollection', 'isBannerFullWidth'],
          },
        ],
      },
      collectionText: {
        sectionHeading: 'Collection Text',
        description: '',
        tooltipContent: '',
        builder: [
          // {
          //   forType: '',
          //   componentLabel: 'Text position',
          //   element: 'multiselect',
          //   accessKey: ['caligraphyCollection','text_placement'],
          //   componentData: TEXT_PLACEMENT,
          //   renderConditional: true,
          //   isVisible(config) {
          //     return config.heading_type === COLLECTION_HEADING_TYPES.IMAGE;
          //   },
          // },
          {
            forType: '',
            componentLabel: 'Text alignment',
            element: 'multiselect',
            accessKey: ['caligraphyCollection', 'text_alignment'],
            componentData: HEADING_ALIGNMENT,
            renderConditional: true,
            isVisible(config) {
              return true;
            },
          },
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Text size - desktop',
            accessKey: ['caligraphyCollection', 'text_size_desktop'],
            dropdownData: TEXT_SIZE_FOR_CAT_COL,
            customChildRender: false,
            placeholder: '',
          },
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Text size - mobile',
            accessKey: ['caligraphyCollection', 'text_size_mobile'],
            dropdownData: TEXT_SIZE_FOR_CAT_COL,
            customChildRender: false,
            placeholder: '',
          },
          {
            componentLabel: 'Advanced settings',
            componentSubLabel: 'Customise content thickness, colour.',
            element: 'customModal',
            modalHeading: 'Advance settings',
            componentData: [
              {
                forType: '',
                componentLabel: 'Text case',
                element: 'multiselect',
                accessKey: ['caligraphyCollection', 'text_case'],
                componentData: TEXT_CASE,
              },
              {
                element: 'separator',
              },
              {
                element: 'colorDetails',
                componentLabel: 'Colours',
                forType: '',
                colorsData: [
                  {
                    forType: '',
                    text: 'text_color',
                    displayVal: 'Text color',
                    accessKey: ['caligraphyCollection', 'text_color'],
                    shouldUpdateData: false,
                    data: [],
                  },
                ],
              },
              {
                element: 'separator',
              },
              {
                forType: '',
                element: 'dropdown',
                componentLabel: 'Text thickness',
                accessKey: ['caligraphyCollection', 'text_thickness'],
                dropdownData: TEXT_THICKNESS,
                customChildRender: false,
                placeholder: '',
              },
            ],
          },
        ],
      },
    },
    caligraphyCategory: {
      headingType: {
        sectionHeading: 'Category heading type',
        sectionSubHeading: 'Any heading type chosen will be applied to all collections.',
        tooltipContent: '',
        builder: [
          {
            forType: '',
            element: 'radioButton',
            componentLabel: '',
            accessKey: ['caligraphyCategory', 'heading_type'],
            handleUpdateConfig: (activeWidgetProps, onChange) => {
              const updatedConfig = cloneDeep(activeWidgetProps);
              const { caligraphyCategory } = updatedConfig;
              if (caligraphyCategory?.isBannerFullWidth) {
                caligraphyCategory.text_size_desktop = 'displayLarge';
                caligraphyCategory.text_size_mobile = 'displayRegular';
                caligraphyCategory.text_thickness = 'regular';
                caligraphyCategory.text_alignment = 'center'
                onChange(updatedConfig)
              }
            },
            componentData: [
              {
                label: 'Text (Category name)',
                id: COLLECTION_HEADING_TYPES.TEXT,
                value: COLLECTION_HEADING_TYPES.TEXT,
              },
              {
                label: 'Image (Category image)',
                id: COLLECTION_HEADING_TYPES.IMAGE,
                value: COLLECTION_HEADING_TYPES.IMAGE,
              },
              // {
              //   label: 'Custom image/banner',
              //   id: COLLECTION_HEADING_TYPES.CUSTOM_IMG_OR_BANNER,
              //   value: COLLECTION_HEADING_TYPES.CUSTOM_IMG_OR_BANNER,
              // },
            ],
          },
        ],
      },
      imageSection: {
        sectionHeading: 'Image',
        description: '',
        tooltipContent: '',
        isVisible(config) {
          return config?.caligraphyCategory?.heading_type === COLLECTION_HEADING_TYPES.IMAGE;
        },
        builder: [
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Image height',
            accessKey: ['caligraphyCategory', 'height'],
            dropdownData: DIMENSIONS_DATA,
            customChildRender: false,
            placeholder: '',
            customInputLabel: 'Custom height',
            customInputSuffix: 'px',
            dropdownInfo: 'Mobile image height is best optimised as per mobile phones.'
          },
          {
            forType: '',
            componentLabel: 'Improve text readability',
            componentSubLabel: 'Image overlay',
            element: 'slider',
            accessKey: ['caligraphyCategory', 'overlay'],
            min: 1,
            max: 100,
            suffix: '%',
            step: 1,
          },
          {
            forType: '',
            element: 'checkbox',
            componentLabel: 'Make image full width',
            accessKey: ['caligraphyCategory', 'isBannerFullWidth'],
          },
        ],
      },
      collectionText: {
        sectionHeading: 'Category Text',
        description: '',
        tooltipContent: '',
        builder: [
          // {
          //   forType: '',
          //   componentLabel: 'Text position',
          //   element: 'multiselect',
          //   accessKey: ['caligraphyCategory','text_placement'],
          //   componentData: TEXT_PLACEMENT,
          //   renderConditional: true,
          //   isVisible(config) {
          //     return config.heading_type === COLLECTION_HEADING_TYPES.IMAGE;
          //   },
          // },
          {
            forType: '',
            componentLabel: 'Text alignment',
            element: 'multiselect',
            accessKey: ['caligraphyCategory', 'text_alignment'],
            componentData: HEADING_ALIGNMENT,
            renderConditional: true,
            isVisible(config) {
              return true;
            },
          },
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Title size - Desktop',
            accessKey: ['caligraphyCategory', 'text_size_desktop'],
            dropdownData: TEXT_SIZE_FOR_CAT_COL,
            customChildRender: false,
            placeholder: '',
          },
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Title size - Mobile',
            accessKey: ['caligraphyCategory', 'text_size_mobile'],
            dropdownData: TEXT_SIZE_FOR_CAT_COL,
            customChildRender: false,
            placeholder: '',
          },

          {
            componentLabel: 'Advanced settings',
            componentSubLabel: 'Customise content thickness, colour.',
            element: 'customModal',
            modalHeading: 'Advance settings',
            componentData: [
              {
                forType: '',
                componentLabel: 'Text case',
                element: 'multiselect',
                accessKey: ['caligraphyCategory', 'text_case'],
                componentData: TEXT_CASE,
              },
              {
                element: 'separator',
              },
              {
                element: 'colorDetails',
                componentLabel: 'Colours',
                forType: '',
                colorsData: [
                  {
                    forType: '',
                    text: 'text_color',
                    displayVal: 'Text color',
                    accessKey: ['caligraphyCategory', 'text_color'],
                    shouldUpdateData: false,
                    data: [],
                  },
                ],
              },
              {
                element: 'separator',
              },
              {
                forType: '',
                element: 'dropdown',
                componentLabel: 'Text thickness',
                accessKey: ['caligraphyCategory', 'text_thickness'],
                dropdownData: TEXT_THICKNESS,
                customChildRender: false,
                placeholder: '',
              },
            ],
          },
        ],
      },
    },
    gridAndPagination: {
      productGrid: {
        sectionHeading: 'Product grid',
        sectionSubHeading: '',
        tooltipContent: '',
        builder: [
          {
            forType: '',
            componentLabel: 'Number of columns desktop',
            element: 'slider',
            accessKey: ['gridAndPagination', 'num_columns_desktop'],
            min: 2,
            max: 6,
            suffix: '',
            step: 1,
          },
          {
            forType: '',
            componentLabel: 'Number of columns mobile',
            element: 'slider',
            accessKey: ['gridAndPagination', 'num_columns_mobile'],
            min: 1,
            max: 2,
            suffix: '',
            step: 1,
          },
        ],
      },
      paginationSection: {
        sectionHeading: 'Pagination',
        sectionSubHeading: '',
        tooltipContent: '',
        builder: [
          {
            forType: '',
            componentLabel: 'Desktop pagination style',
            element: 'multiselect',
            accessKey: ['gridAndPagination', 'pagination_style_desktop'],
            componentData: PAGINATION_STYLE,
          },
          {
            forType: '',
            componentLabel: 'Mobile pagination style',
            element: 'multiselect',
            accessKey: ['gridAndPagination', 'pagination_style_mobile'],
            componentData: PAGINATION_STYLE,
          },
          {
            forType: '',
            componentLabel: 'Pagination appearance',
            element: 'layoutComponent',
            showBorder: false,
            configWidth: '450px',
            layoutPreviewType: 'thumbnail',
            layoutPreviewSize: 'medium',
            accessKey: ['gridAndPagination', 'pagination_appearance'],
            layoutData: PAGINATION_APPEARANCE_LAYOUTS,
          },
          {
            forType: '',
            componentLabel: 'Number of products per page desktop',
            element: 'slider',
            accessKey: ['gridAndPagination', 'num_products_desktop'],
            min: 16,
            max: 40,
            suffix: '',
            step: 1,
          },
          {
            forType: '',
            componentLabel: 'Number of products per page mobile',
            element: 'slider',
            accessKey: ['gridAndPagination', 'num_products_mobile'],
            min: 16,
            max: 40,
            suffix: '',
            step: 1,
          },
        ],
      },
    },
    sortAndFilter: {
      productGrid: {
        sectionHeading: 'Filter design and layout',
        sectionSubHeading: '',
        tooltipContent: '',
        builder: [
          {
            forType: '',
            componentLabel: 'Desktop layout',
            element: 'layoutComponent',
            layoutPreviewType: 'thumbnail',
            layoutPreviewSize: 'medium',
            showBorder: false,
            configWidth: '450px',
            accessKey: ['sortAndFilter', 'layout_desktop'],
            layoutData: FILTER_DESIGN_LAYOUTS_DESKTOP,
          },
          {
            forType: '',
            componentLabel: 'Mobile layout',
            element: 'layoutComponent',
            layoutPreviewType: 'thumbnail',
            layoutPreviewSize: 'small',
            showBorder: false,
            configWidth: '220px',
            accessKey: ['sortAndFilter', 'layout_mobile'],
            layoutData: FILTER_DESIGN_LAYOUTS_MOBILE,
          },
        ],
      },
      textConfigurations: {
        sectionHeading: 'Text configurations',
        description: '',
        tooltipContent: '',
        isSectionVisible: (data) => data?.layout_desktop !== 'layout0',
        builder: [
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Title size - Desktop',
            accessKey: ['sortAndFilter', 'desktop_configs', 'title_size'],
            dropdownData: TEXT_SIZE_DROPDOWN,
            customChildRender: false,
            placeholder: '',
          },
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Title size - Mobile',
            accessKey: ['sortAndFilter', 'mobile_configs', 'title_size'],
            dropdownData: TEXT_SIZE_DROPDOWN,
            customChildRender: false,
            placeholder: '',
          },
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Filter options size - desktop',
            accessKey: ['sortAndFilter', 'desktop_configs', 'filter_options_size'],
            dropdownData: TEXT_SIZE_DROPDOWN,
            customChildRender: false,
            placeholder: '',
          },
          {
            forType: '',
            element: 'dropdown',
            componentLabel: 'Filter options size - mobile',
            accessKey: ['sortAndFilter', 'mobile_configs', 'filter_options_size'],
            dropdownData: TEXT_SIZE_DROPDOWN,
            customChildRender: false,
            placeholder: '',
          },
          {
            componentLabel: 'Edit text clor and thickness',
            componentSubLabel: 'Customise text colors and thickness',
            element: 'customModal',
            modalHeading: 'Advance settings',
            componentData: [
              {
                forType: '',
                componentLabel: 'Title case',
                element: 'multiselect',
                accessKey: ['sortAndFilter', 'title_case'],
                componentData: TEXT_CASE,
              },
              {
                forType: '',
                componentLabel: 'Filter options case',
                element: 'multiselect',
                accessKey: ['sortAndFilter', 'filter_options_case'],
                componentData: TEXT_CASE,
              },
              {
                element: 'separator',
              },
              {
                element: 'colorDetails',
                componentLabel: 'Colours',
                forType: '',
                colorsData: [
                  {
                    forType: '',
                    text: 'title_color',
                    displayVal: 'Text color',
                    accessKey: ['sortAndFilter', 'title_color'],
                    shouldUpdateData: false,
                    data: [],
                  },
                ],
              },
              {
                element: 'colorDetails',
                componentLabel: 'Colours',
                forType: '',
                colorsData: [
                  {
                    forType: '',
                    text: 'filter_options_color',
                    displayVal: 'Text color',
                    accessKey: ['sortAndFilter', 'filter_options_color'],
                    shouldUpdateData: false,
                    data: [],
                  },
                ],
              },
              {
                element: 'separator',
              },
              {
                forType: '',
                element: 'dropdown',
                componentLabel: 'Text thickness',
                accessKey: ['sortAndFilter', 'title_thickness'],
                dropdownData: TEXT_THICKNESS,
                customChildRender: false,
                placeholder: '',
              },
              {
                forType: '',
                element: 'dropdown',
                componentLabel: 'Text thickness',
                accessKey: ['sortAndFilter', 'filter_options_thickness'],
                dropdownData: TEXT_THICKNESS,
                customChildRender: false,
                placeholder: '',
              },
            ],
          },
        ],
      },
      filterBehaviourSection: {
        sectionHeading: 'Filter behaviour',
        description: '',
        tooltipContent: '',
        isSectionVisible: (data) => data?.layout_desktop !== 'layout0',
        builder: [
          {
            forType: '',
            element: 'checkbox',
            componentLabel: 'Show filters in open state',
            accessKey: ['sortAndFilter', 'keep_filters_open'],
          },
        ],
      },
      filterAppearances: {
        sectionHeading: 'Filter appearances',
        sectionSubHeading: '',
        tooltipContent: '',
        isSectionVisible: (data) => data?.layout_desktop !== 'layout0',
        builder: [
          {
            forType: '',
            componentLabel: 'Color selection',
            element: 'layoutComponent',
            layoutPreviewType: 'thumbnail',
            showBorder: false,
            configWidth: '220px',
            layoutPreviewSize: 'medium',
            accessKey: ['sortAndFilter', 'appearances', 'color'],
            layoutData: COLOR_SELECTION_LAYOUTS,
          },
          {
            forType: '',
            componentLabel: 'Size selection',
            element: 'layoutComponent',
            showBorder: false,
            configWidth: '220px',
            layoutPreviewType: 'thumbnail',
            layoutPreviewSize: 'medium',
            accessKey: ['sortAndFilter', 'appearances', 'size'],
            layoutData: SIZE_SELECTION_LAYOUTS,
          },
        ],
      },
    },
  },
};

export const BUILDER_HEADING_BY_TYPE = {
  caligraphyCollection: 'Collection heading',
  caligraphyCategory: 'Category heading',
  sortAndFilter: 'Page layout and design',
  gridAndPagination: 'Grid and pagination',
};

export const LAYOUT_WISE_CONFIG = {
  layout0: {},
  layout1: {
    sortAndFilter: {
      desktop_configs: {
        filter_options_size: 'medium'
      },
      filter_options_thickness: 'regular',
      filter_options_color: '#586072'
    },
    collectionCategory: {
      text_size_desktop: 'extraLarge',
      text_size_mobile: 'large'
    }
  },
  layout2: {
    sortAndFilter: {
      desktop_configs: {
        filter_options_size: 'medium'
      },
      filter_options_thickness: 'regular',
      filter_options_color: '#586072'
    },
    collectionCategory: {
      text_size_desktop: 'displayLarge',
      text_size_mobile: 'large'
    }
  },
  layout3: {
    sortAndFilter: {
      desktop_configs: {
        title_size: 'regular',
        filter_options_size: 'medium'
      },
      title_thickness: 'regular',
      title_color: '#586072',
      filter_options_thickness: 'regular',
      filter_options_color: '#586072'
    },
    collectionCategory: {
      text_size_desktop: 'displayLarge',
      text_size_mobile: 'large'
    }
  }
}
